<template>
	<div class="finance-entry" @click="openFinanceCalculator">
		<div class="finance-entry__name">
			金融方案 {{ car.finance && car.finance.product_name }}
			<div class="finance-entry__desc">{{ car.finance && car.finance.tips }}</div>
		</div>
		<div class="finance-entry__action">
			<span>去算算</span>
			<nio-icon name="icon_arrows_right_2xs" :size="12" />
		</div>
	</div>
</template>

<script>
import link from '@/util/link'
import util from '@/util/util'
export default {
	name: 'FinanceEntry',
	props: {
		car: {
			type: Object,
			required: true
		}
	},
	methods: {
		openFinanceCalculator() {
			const query = { sku_code: this.car.basic.commodity_code, wv: 'lg', is_nav_show: 'false' }
			if (util.isInWebview()) {
				link.goToRoute('/finance-calculator', query)
			} else {
				this.$router.push({ path: '/finance-calculator', query })
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-entry {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 15px;
	background: #f7f7f7;
	margin-top: 8px;

	&::before {
		position: absolute;
		top: -12px;
		left: 50px;
		width: 0;
		height: 0;
		border: 6px solid transparent;
		border-bottom: 6px solid #f7f7f7;
		content: '';
	}
}

.finance-entry__name {
	color: #050b27;
	@include body_3(1.5, 400, false);
}
.finance-entry__desc {
	color: #999dae;
	font-size: 10px;
	align-self: flex-end;
	flex: 1;
	margin-right: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.finance-entry__action {
	font-size: 12px;
	color: #999dae;
}
</style>
